var map = {
	"./business-trip.png": "bfc8",
	"./cash-advance.png": "5a23",
	"./chart.png": "3be8",
	"./dept.png": "8287",
	"./invoice.png": "4761",
	"./policy.png": "74ac",
	"./reimbursement.png": "458b",
	"./role.png": "2055",
	"./seal.png": "92bf",
	"./shortcut-1.png": "ce71",
	"./shortcut-2.png": "5dbd",
	"./shortcut-3.png": "b6fc",
	"./shortcut-4.png": "0ca9",
	"./shortcut-5.png": "663d",
	"./shortcut-6.png": "bab5",
	"./shortcut.png": "40d3",
	"./supplier-contract.png": "6778",
	"./trend.png": "1788"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a233";